<template>
  <div>
    <v-layout wrap>
      <v-flex xs12>
        <v-divider class="primary"/>
      </v-flex>
    </v-layout>
    <v-banner class="banner-without-padding py-1" style="top:50px; z-index:1" sticky color="primary" single-line>
      <v-layout wrap class="primary white--text" px-2>
        <v-flex xs4>
          <v-layout wrap justify-space-between>
            <v-flex>
              <v-btn @click="addEducation" x-small outlined class="white" elevation="0">
                <v-icon x-small class="mr-1">mdi-plus</v-icon>
                {{ $t('c') }}
              </v-btn>
            </v-flex>
            <v-flex>
              <v-btn @click="isShowingReorderEducationsDialog = true" x-small outlined class="white" elevation="0" v-if="dossier.profile.educations.length >= 2">
                <v-icon x-small class="mr-1">mdi-arrow-split-horizontal</v-icon>
                {{ $t('e') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs4 text-center>
          <h3>
            <span>{{ $t('d') }}</span>
            <v-icon small class="ml-2 primary--text">mdi-pen</v-icon>
          </h3>
        </v-flex>
        <v-flex xs4 text-end>
          <div>
            <v-btn @click="goToSelectEntireListOfEducationsAndCertifications" x-small outlined class="white secondary white--text" elevation="0">
              <v-icon x-small class="mr-1">mdi-refresh</v-icon>
              <span>{{ $t('e2') }}</span>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-banner>
    <v-layout wrap>
      <v-flex xs12>
        <v-divider/>
        <v-layout wrap>
          <v-flex xs12>
            <v-layout wrap v-for="(education, index) in dossier.profile.educations" :key="index" :id="`view-educations-${index}`">
              <v-hover v-slot="{ hover }">
                <v-flex xs12 :class="{ 'hoveredBackground': hover }" class="cursorPointer" @click="editEducation(index)">
                  <v-layout wrap>
                    <v-flex xs3 class="leftCell" pl-1>
                      <b>{{ $t('f') }} {{ index + 1 }}</b>
                      <v-icon v-if="hover" small class="ml-2">mdi-pen</v-icon>
                    </v-flex>
                    <v-flex xs9>
                      <view-education-or-certification :educationOrCertification="education" />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-hover>
              <v-flex xs12>
                <v-divider class="primary"/>
              </v-flex>
            </v-layout>
            <v-layout wrap v-if="dossier.profile.educations.length === 0">
              <v-flex xs3>
              </v-flex>
              <v-flex xs9 pl-2>
                <i>{{ $t('k') }}</i>
              </v-flex>
              <v-flex xs12>
                <v-divider class="primary"/>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-dialog v-model="isShowingReorderEducationsDialog" persistent v-if="isShowingReorderEducationsDialog" width="80%">
      <v-card class="pa-6">
        <v-layout wrap>
          <v-flex xs12>
            <div class="mb-6 text-center">
              <h3>{{ $t('a') }}</h3>
              <small>{{ $t('b') }}</small>
            </div>
            <reorder-educations :educations="dossier.profile.educations" @updateEducationsOrder="updateEducationsOrder"/>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import ReorderEducations from '@/components/profile/ReorderEducations'
import ViewEducationOrCertification from '@/components/profile/ViewEducationOrCertification'

export default {
  components: {
    ReorderEducations,
    ViewEducationOrCertification
  },
  props: {
    dossier: Object
  },
  data: () => ({
    isShowingReorderEducationsDialog: false
  }),
  methods: {
    addEducation() {
      this.dossier.profile.educations.push({
        startYear: "",
        endYear: "",
        institute: "",
        description: "",
        location: ""
      })
      setTimeout(() => {
        const newElt = document.getElementById(`view-educations-${this.dossier.profile.educations.length - 1}`)
        // Scroll to new element
        newElt.scrollIntoView({behavior : "smooth", block: "center" })
        // Make the last item edited flash in green for a small time
        setTimeout(() => {
          const originalBackgroundColor = newElt.style.backgroundColor
          newElt.style.backgroundColor = 'rgba(0, 200, 83, 0.3)'
          setTimeout(() => {
            newElt.style.backgroundColor = originalBackgroundColor
          }, 1200)
        }, 500)
      })
    },
    editEducation(index) {
      this.$emit('setFieldPath', { fieldPath: ['educations', index], savedScrollEltId: `view-educations` })
    },
    goToSelectEntireListOfEducationsAndCertifications() {
      this.$emit('setFieldPath', { fieldPath: ['selectEntireListOfEducationsAndCertifications'], savedScrollEltId: `view-educations` })
    },
    updateEducationsOrder(newEducations) {
      this.dossier.profile.educations = JSON.parse(JSON.stringify(newEducations))
      this.isShowingReorderEducationsDialog = false
    }
  }
}
</script>


<i18n>
{
  "fr": {
    "a": "Réordonner les diplômes",
    "b": "Réorganisez les diplômes dans l'ordre que vous souhaitez.",
    "c": "Ajouter",
    "d": "Diplômes",
    "e": "Réordonner",
    "f": "Diplôme",
    "k": "Aucun diplôme.",
    "e2": "Diplômes mal extraits ?"
  },
  "en": {
    "a": "Re-order the diplomas",
    "b": "Sort the diplomas the way you want.",
    "c": "Add",
    "d": "Diplomas",
    "e": "Re-order",
    "f": "Diploma",
    "k": "No diploma.",
    "e2": "Educations badly extracted ?"
  }
}
</i18n>